import React, {useState} from "react"
import 'aos/dist/aos.css';
import './Welcome.css'
import ButtonArrow from '../ButtonArrow'

function Welcome() {

  const [subtitle] = useState("Our Mission is to organize the Worlds Information")
  const [mainButton] = useState({label: "Contact Us", url: "#contact_us"})
  const [sideButton] = useState({label: "Our Portfolio", url: "#realestate"})
  return (
    <div>
      {/* Canvas displaying the constellation effect */}
      <canvas className="constellation" id="background" style={{width: '100%', height: '500px'}}></canvas>
      
      <section class="pt-4 pt-md-11">
        <div class="container company_name">
          <div class="row align-items-center">
            <div class="col-12 col-md-5 col-lg-6 order-md-2">

            </div>

            <div class='col-3' id='mobile_show'></div>
            <div class="col-md-7 col-lg-6 col-sm-12 col-xs-12 order-md-1" data-aos="fade-up">

              {/* Heading */}
              <h1 class="display-3 text-center text-md-left" style={{fontSize: '3.5rem'}}>
                <span style={{ color: '#335eea', fontWeight: 'bold' }}>Delta</span> Parse
              </h1>

              {/* Text */}
              <p class="lead text-center text-md-left text-muted mb-6 mb-lg-8 mb-sm-8 mb-xs-12">{subtitle}</p>

              {/* Buttons */}
              <div class="text-center text-md-left">
                <a href={mainButton.url} class="btn btn-primary shadow lift mr-1">{mainButton.label}<ButtonArrow direction="right"/></a>
                <a href={sideButton.url} class="btn btn-primary-soft lift">{sideButton.label}</a>
              </div>

            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Welcome
